import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useClinicModule } from '../../hooks/queries/usePharmacyFeatures';

/**
 * PRX-44 decision 2: a clinic / IV route on a pharmacy whose module is off
 * redirects to the home page instead of rendering an orphaned screen (its API
 * answers 404 for that pharmacy anyway). While the flags load it shows the
 * same neutral spinner the lazy routes use.
 */
export const ClinicModuleRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { enabled, loading } = useClinicModule();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress size={28} />
      </Box>
    );
  }
  if (!enabled) return <Navigate to="/" replace />;
  return <>{children}</>;
};
